<script lang="ts" setup>
const _props = defineProps<{
  open?: boolean
  suggestionsText?: string
  suggestions?: string[]
}>()

const route = useRoute()
const emit = defineEmits(['close'])
</script>

<template>
  <aside
    class="fixed top-0 left-0 z-20 h-screen w-screen overflow-auto overscroll-contain bg-(--green-1) text-(--sand)"
  >
    <div class="relative z-2 flex h-full flex-col justify-between">
      <div class="px-bleed">
        <Search
          :suggestions="suggestions"
          :suggestionsText="suggestionsText"
          @close="() => emit('close')"
        />
      </div>
    </div>
  </aside>
</template>
